import { observable_component } from 'common/util/ComponentDecorator';
import ModalUtil from 'common/util/ModalUtil';
import './open-video-link.scss';

@observable_component
export default class OpenVideoLink {
	static classname = 'open-video-link';

	constructor($videolink) {
		this.$videolink = $videolink;
		this.bindEvents();
	}

	bindEvents = () => {
		const self = this;
		this.$videolink.on('click', function (e) {
			e.preventDefault();
			self.openModal();
		})
	};

	openModal = () => {
		const self = this;
		const regExp = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*?[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
		const match = this.$videolink.attr('href').match(regExp);
		const url = match[1];

		if (url !== undefined) {
			const $modal = $(window.elkitorg_config.modal_template);
			const $iframe = $(`<iframe src="https://www.youtube.com/embed/${url}" width="800" height="451" frameborder="0" allowfullscreen></iframe>`);

			$modal.addClass('open-video-link-modal');
			$modal.find('.modal__inner').append($iframe);

			ModalUtil.openContent($modal);
		}
	}
}
